'use strict';

module.exports = require('./slider');


/*****************
 ** WEBPACK FOOTER
 ** ./~/_react-slick@0.14.11@react-slick/lib/index.js
 ** module id = 680
 ** module chunks = 0 1
 **/